<template>
  <section id="ourfaq" class="bglight position-relative padding">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center wow fadeIn" data-wow-delay="300ms">
          <h2 class="heading bottom40 darkcolor font-light2">
            <span class="font-normal">Validasi Dokumen Surat Keterangan</span>
            <span class="divider-center"></span>
          </h2>
          <div class="col-md-8 offset-md-2 heading_space">
            <p>
              <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. A dolores
        explicabo laudantium, omnis provident quam reiciendis voluptatum? -->
            </p>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 pr-lg-0 whitebox noshadow">
          <b-overlay :show="loadingCard" rounded="sm">
            <div class="widget logincontainer" v-if="!loadingCard">
              <center v-if="resultData != null">
                <img
                  src="img/success.png"
                  style="width: 80px"
                  class="text-center"
                  alt=""
                />
                <br />
                <br />
                <h3 class="text-success">Dokumen Valid</h3>
              </center>
              <center v-if="resultData == null">
                <img
                  src="img/error.png"
                  style="width: 80px"
                  class="text-center"
                  alt=""
                />
                <br />
                <br />
                <h3 class="text-danger">Url Tidak Valid</h3>
              </center>
              <br />
              <br />
              <table class="table" v-if="resultData">
                <tr>
                  <th style="width: 40%">
                    Nama (badan usaha/ nonbadan usaha/ perseorangan
                  </th>
                  <th>: {{ resultData.nama_badan_usaha }}</th>
                </tr>
                <tr>
                  <th style="width: 30%">Alamat</th>
                  <th>: {{ resultData.alamat }}</th>
                </tr>
                <tr>
                  <th style="width: 30%">No. Tlp/Fax/HP</th>
                  <th>
                    :
                    {{ resultData.no_telp != "" ? resultData.no_telp : "-" }} /
                    {{ resultData.no_fax != "" ? resultData.no_fax : "-" }} /
                    {{ resultData.no_hp != "" ? resultData.no_hp : "-" }}
                  </th>
                </tr>
                <tr>
                  <th style="width: 30%">NIB untuk badan usaha / NIK</th>
                  <th>: {{ resultData.no_identitas }}</th>
                </tr>
                <tr>
                  <th style="width: 30%">NPWP</th>
                  <th>: {{ resultData.npwp }}</th>
                </tr>
                <tr>
                  <th style="width: 30%">
                    Lokasi Instalasi Penyedia Tenaga Listrik
                  </th>
                  <th>: {{ resultData.lokasi_alamat }}</th>
                </tr>
                <tr>
                  <th style="width: 30%">Kapasitas</th>
                  <th v-if="resultData.teknis_jenis_pembangkit == 'PLTD'">
                    :
                    <template
                      v-for="item in resultData.kategori_pembangkit"
                      :key="item"
                    >
                      <template v-if="item.jenis == 'Generator'">
                        {{ item.kapasitas }} KW
                      </template>
                    </template>
                  </th>
                  <th v-if="resultData.teknis_jenis_pembangkit == 'PLTS'">
                    <div
                      v-for="(item, index) in resultData.kategori_pembangkit"
                      :key="index"
                    >
                      <span v-html="getKapasitas(item, index)">
                       
                      </span>
                    </div>
                  </th>
                </tr>

                <tr>
                  <th style="width: 30%">Penggunaan</th>
                  <th>: {{ resultData.jenis_penggunaan }} </th>
                </tr>
              </table>
            </div>
          </b-overlay>
        </div>
        <!-- <div class="col-lg-6 d-none d-lg-block pl-lg-0">
          <div class="image login-image h-100">
            <img src="/img/auth-bg.png" alt="" />
          </div>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/store/auth";
import { useToast, TYPE } from "vue-toastification";
import JwtService from "@/core/services/JwtService";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "LoginView",
  components: {},
  setup() {
    const authStore = useAuthStore();
    const loadingCard = ref(false);
    const toast = useToast();
    const route = useRoute();

    const uuid = route.query.token as string;
    // console.log("uuid", uuid);

    const resultData: any = ref(null);
    // console.log("resultData", resultData.value);
    const getData = async () => {
      loadingCard.value = true;
      await authStore
        .validateSuket(uuid)
        .then((res) => {
          loadingCard.value = false;
          resultData.value = res.data.data;
          //   console.log("resultData", resultData.value);
        })
        .catch((err) => {
          loadingCard.value = false;
          resultData.value = null;
        });
    };

    const formatDate = (dates: string) => {
      let dateStr = dates;
      let dateObj = new Date(dateStr);

      let day = String(dateObj.getDate()).padStart(2, "0");
      let month = String(dateObj.getMonth() + 1).padStart(2, "0"); // January is 0!
      let year = dateObj.getFullYear();

      let hours = dateObj.getHours();
      let minutes = dateObj.getMinutes();

      let newDateStr = `${day}/${month}/${year} ${hours}.${minutes}`;

      return newDateStr;
    };

    const listAlphabet = ["a", "b"];

    const getKapasitas = (item: any, index: number) => {
      let total_kapasitas = item.jumlah * item.kapasitas;
      return `${listAlphabet[index]}. ${item.jenis} : ${item.jumlah} unit x ${item.kapasitas} = ${total_kapasitas}`;
    };

    onMounted(async () => {
      await getData();
    });

    return {
      loadingCard,
      authStore,
      toast,
      resultData,
      formatDate,
      getKapasitas,
    };
  },
});
</script>
